import { Box, Link } from '@mui/material';
import { ConditionalLoader, Section } from 'dashboard409a/pages/Operations/components';
import Avatar from 'dashboard409a/pages/Operations/components/Avatar/Avatar';
import formatCurrency from 'dashboard409a/utilities/formatCurrency';
import { ValuedInformationProps } from './ValuedInformation.props';
import { Container, Field, HeaderRow, Label, LabelRow, Row, StatusBadge, StyledLinkSpan, UserSection, Value } from './ValuedInformation.styles';

const ValuedInformation = ({ valuedInformation, isLoading }: ValuedInformationProps) => (
  <Section title="Valuation">
    <Container>
      <HeaderRow>
        <Field>
          <ConditionalLoader isLoading={isLoading} width={200}>
            <Link href={valuedInformation?.valuationUrl} target="_blank" rel="noopener noreferrer">
              <StyledLinkSpan>{valuedInformation?.valuationName || '-'}</StyledLinkSpan>
            </Link>
          </ConditionalLoader>
        </Field>
        <ConditionalLoader isLoading={isLoading} width={200}>
          <StatusBadge>{valuedInformation?.bookingType || '-'}</StatusBadge>
        </ConditionalLoader>
      </HeaderRow>
      {valuedInformation?.valuationNotice && (
        <span>NOTICE: {valuedInformation.valuationNotice}</span>
      )}
      <Box mt={1} />
      <LabelRow>
        <Label>Valuation Fee:</Label>
        <ConditionalLoader isLoading={isLoading} width={200}>
          <Value>{formatCurrency({ value: valuedInformation?.valuationFee || 0 })}</Value>
        </ConditionalLoader>
        <Label>Net Value:</Label>
        <ConditionalLoader isLoading={isLoading} width={200}>
          <Value>{formatCurrency({ value: valuedInformation?.valuationNetValue || 0 })}</Value>
        </ConditionalLoader>
      </LabelRow>
      <Row>
        <Field>
          <Label>Valuation Lead</Label>
          <UserSection>
            <Avatar
              src={valuedInformation?.valuationLeadImageSrc || ''}
              name={valuedInformation?.valuationLeadName || '-'}
              roleTitle="Valuation Lead"
              isLoading={isLoading}
            />
          </UserSection>
        </Field>
        <Field>
          <Label>Valuation Date</Label>
          <ConditionalLoader isLoading={isLoading} width={200}>
            <Value>{valuedInformation?.valuationDate || '-'}</Value>
          </ConditionalLoader>
          <Label>Booking Date</Label>
          <ConditionalLoader isLoading={isLoading} width={200}>
            <Value>{valuedInformation?.bookingDate || '-'}</Value>
          </ConditionalLoader>
        </Field>
       
        <Field>
          <Label>Renewal Date</Label>
          <ConditionalLoader isLoading={isLoading} width={200}>
            <Value>{valuedInformation?.renewalDate || '-'}</Value>
          </ConditionalLoader>
          <Field>
            <Label>Engagement Manager</Label>
            <UserSection>
              <Avatar
                src={valuedInformation?.valuationEngagementManagerImageSrc || ''}
                name={valuedInformation?.valuationEngagementManager || '-'}
                roleTitle={valuedInformation?.valuationEngagementManagerRole || '-'}
                isLoading={isLoading}
              />
            </UserSection>
          </Field>
        </Field>
      </Row>
    </Container>
  </Section>
);

export default ValuedInformation;
